document.addEventListener("DOMContentLoaded", function () {
  initJvLenisGsap();
  initJvGlobalFades();
  initHomepageHeroLoad();
  initJvHeroScrollHint();
  initJvBenefitCardsModal();
  initJvStickyWhyImages();
  initJvScienceLabScroll();
  initJvRitualCinematicScroll();
  initJvTransformationExtras();
  initTabs();
  initJvProductBodySystems();
  initJvPdpStickyBuyBar();
  initJvLandingStickyBuyBar();
  initSealDefaultSubscribe();

  setTimeout(function () {
    if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
  }, 100);
});

function initJvLenisGsap() {
  if (typeof Lenis === "undefined") return;
  try {
    var lenis = new Lenis({
      duration: 1.1,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
    });
    window.jvLenis = lenis;

    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
      lenis.on("scroll", ScrollTrigger.update);
      gsap.ticker.add(function (time) {
        lenis.raf(time * 1000);
      });
      gsap.ticker.lagSmoothing(0);
    } else {
      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    }
  } catch (e) {
    console.warn("[Jivaka] Smooth scroll skipped", e);
  }
}

function initJvGlobalFades() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  document.querySelectorAll(".jv-fade").forEach(function (el) {
    gsap.fromTo(
      el,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power3.out",
        immediateRender: false,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      }
    );
  });

  document.querySelectorAll(".jv-fade-stagger").forEach(function (parent) {
    gsap.fromTo(
      parent.children,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: "power3.out",
        immediateRender: false,
        scrollTrigger: {
          trigger: parent,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      }
    );
  });
}

function initHomepageHeroLoad() {
  if (typeof gsap === "undefined") return;
  var hero = document.getElementById("homepage-hero");
  if (!hero) {
    hero = document.getElementById("jv-hero");
    if (!hero || !hero.classList.contains("jv-hero--path-a")) return;
    var legacy = gsap.utils.toArray(hero.querySelectorAll("[data-jv-hero-seq]"));
    if (!legacy.length) return;
    gsap.fromTo(
      legacy,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.15,
        ease: "power3.out",
        delay: 0.1,
        immediateRender: false,
      }
    );
    return;
  }
  var seq = gsap.utils.toArray(hero.querySelectorAll("[data-hp-seq]"));
  if (!seq.length) return;
  gsap.fromTo(
    seq,
    { opacity: 0, y: 40 },
    {
      opacity: 1,
      y: 0,
      duration: 1,
      stagger: 0.15,
      ease: "power3.out",
      delay: 0.05,
      immediateRender: false,
    }
  );

  var hint = hero.querySelector(".hp-hero__scroll-inner");
  if (hint && typeof gsap !== "undefined") {
    var arrow = hint.querySelector(".hp-hero__scroll-arrow");
    if (arrow) {
      gsap.to(arrow, { y: 6, repeat: -1, yoyo: true, duration: 0.9, ease: "power1.inOut" });
    }
  }
}

function initJvHeroScrollHint() {
  document.querySelectorAll("[data-jv-hero-scroll-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var selector = btn.getAttribute("data-jv-scroll-target");
      var target = selector ? document.querySelector(selector) : document.getElementById("for-you");
      var offset = 80;
      if (!target) return;
      if (window.jvLenis && typeof window.jvLenis.scrollTo === "function") {
        window.jvLenis.scrollTo(target, { offset: -offset });
      } else {
        var rect = target.getBoundingClientRect();
        var top = rect.top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
      }
    });
  });
}

/** Benefits rail: vanilla modal */
function initJvBenefitCardsModal() {
  JvBenefitModal.init();
}

var JvBenefitModal = {
  _bound: false,
  el: null,
  init: function () {
    if (JvBenefitModal._bound) return;
    document.body.insertAdjacentHTML(
      "beforeend",
      '<div id="jv-benefit-modal" class="jv-benefit-modal" aria-hidden="true" hidden>' +
        '<div class="jv-benefit-modal__backdrop" data-jv-modal-close tabindex="-1"></div>' +
        '<div class="jv-benefit-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="jv-benefit-modal-title">' +
        '<button type="button" class="jv-benefit-modal__close" data-jv-modal-close aria-label="Close">&times;</button>' +
        '<p class="jv-benefit-modal__eyebrow" id="jv-benefit-modal-label"></p>' +
        '<h3 class="jv-benefit-modal__title" id="jv-benefit-modal-title"></h3>' +
        '<div class="jv-benefit-modal__body"></div>' +
        "</div></div>"
    );
    JvBenefitModal.el = document.getElementById("jv-benefit-modal");
    var root = JvBenefitModal.el;

    root.addEventListener("click", function (e) {
      if (e.target && e.target.getAttribute && e.target.getAttribute("data-jv-modal-close") !== null) {
        JvBenefitModal.close();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        var mod = document.getElementById("jv-benefit-modal");
        if (mod && mod.getAttribute("aria-hidden") === "false") JvBenefitModal.close();
      }
    });

    document.querySelectorAll("[data-benefit-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var title = btn.getAttribute("data-benefit-title") || "";
        var eyebrow = btn.getAttribute("data-benefit-eyebrow") || "";
        var detail = btn.getAttribute("data-benefit-detail") || "";
        JvBenefitModal.open(title, eyebrow, detail);
      });
    });

    JvBenefitModal._bound = true;
  },
  open: function (title, eyebrow, detail) {
    var root = JvBenefitModal.el;
    if (!root || typeof gsap === "undefined") return;

    root.querySelector(".jv-benefit-modal__title").textContent = title;
    root.querySelector(".jv-benefit-modal__eyebrow").textContent = eyebrow;
    var bodyEl = root.querySelector(".jv-benefit-modal__body");
    bodyEl.innerHTML = "";
    var p = document.createElement("p");
    p.style.margin = "0";
    p.style.lineHeight = "1.65";
    p.textContent = detail;
    bodyEl.appendChild(p);

    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var dialog = root.querySelector(".jv-benefit-modal__dialog");
    var backdrop = root.querySelector(".jv-benefit-modal__backdrop");
    gsap.set([backdrop, dialog], { opacity: 0 });
    gsap.set(dialog, { y: 14, scale: 0.98 });
    gsap.to(backdrop, { opacity: 1, duration: 0.28, ease: "power2.out" });
    gsap.to(dialog, { opacity: 1, y: 0, scale: 1, duration: 0.35, ease: "power3.out" });
  },
  close: function () {
    var root = JvBenefitModal.el;
    if (!root || typeof gsap === "undefined") {
      if (root) {
        root.hidden = true;
        root.setAttribute("aria-hidden", "true");
      }
      document.body.style.overflow = "";
      return;
    }
    var dialog = root.querySelector(".jv-benefit-modal__dialog");
    var backdrop = root.querySelector(".jv-benefit-modal__backdrop");
    gsap.to(dialog, {
      opacity: 0,
      y: 8,
      scale: 0.99,
      duration: 0.22,
      ease: "power2.in",
    });
    gsap.to(backdrop, {
      opacity: 0,
      duration: 0.22,
      onComplete: function () {
        root.hidden = true;
        root.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      },
    });
  },
};

function initJvStickyWhyImages() {
  if (typeof window.matchMedia !== "undefined" && window.matchMedia("(min-width: 901px)").matches) return;

  var root = document.getElementById("jv-sticky-why");
  if (!root || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  var imgs = gsap.utils.toArray(root.querySelectorAll(".jv-sticky-img"));
  if (!imgs.length) return;

  function show(iActive) {
    imgs.forEach(function (img, i) {
      gsap.to(img, { opacity: i === iActive ? 1 : 0, duration: 0.6, ease: "power2.out" });
    });
  }

  root.querySelectorAll(".jv-why-beat").forEach(function (beat, index) {
    ScrollTrigger.create({
      trigger: beat,
      start: "top 55%",
      end: "bottom 45%",
      onEnter: function () {
        show(index);
      },
      onEnterBack: function () {
        show(index);
      },
    });
  });

  show(0);
}

function initJvScienceLabScroll() {
  var root = document.querySelector("[data-homepage-science]");
  if (!root || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  var fill = root.querySelector("[data-jvlc-fulvic-fill]");
  if (fill) {
    gsap.set(fill, { width: "0%" });
    ScrollTrigger.create({
      trigger: root,
      start: "top 80%",
      once: true,
      onEnter: function () {
        gsap.to(fill, { width: "76.66%", duration: 1.2, ease: "power2.out" });
      },
    });
  }

  var rows = gsap.utils.toArray(root.querySelectorAll("[data-jvlc-stagger-row]"));
  if (rows.length) {
    gsap.fromTo(
      rows,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 0.55,
        stagger: 0.1,
        ease: "power2.out",
        immediateRender: false,
        scrollTrigger: {
          trigger: root,
          start: "top 78%",
          toggleActions: "play none none none",
        },
      }
    );
  }
}

function initJvRitualCinematicScroll() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  document.querySelectorAll("[data-ritual-step]").forEach(function (block) {
    var img = block.querySelector("[data-ritual-img]");
    if (img) {
      gsap.fromTo(
        img,
        { opacity: 0.7 },
        {
          opacity: 1,
          ease: "none",
          scrollTrigger: {
            trigger: block,
            start: "top 85%",
            end: "center 50%",
            scrub: true,
          },
        }
      );
    }
  });
}

function initJvTransformationExtras() {
  var section = document.getElementById("journey");
  if (!section || typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

  var rail = section.querySelector("[data-transformation-rail]");
  var cards = gsap.utils.toArray(section.querySelectorAll("[data-transformation-card]"));
  if (cards.length) {
    gsap.fromTo(
      cards,
      { opacity: 0, y: 32 },
      {
        opacity: 1,
        y: 0,
        duration: 0.75,
        stagger: 0.18,
        ease: "power2.out",
        immediateRender: false,
        scrollTrigger: {
          trigger: rail || section,
          start: "top 82%",
          toggleActions: "play none none none",
        },
      }
    );
  }
}

function initTabs() {
  document.querySelectorAll("[data-tabs]").forEach((tabs) => {
    const buttons = tabs.querySelectorAll(".jv-tab-btn");
    const contents = tabs.querySelectorAll(".jv-tab-content");
    const wrapper = tabs.querySelector(".jv-tab-wrapper");

    function setWrapperHeight() {
      if (!wrapper || !contents.length) return;

      let maxHeight = 0;

      contents.forEach((content) => {
        const wasActive = content.classList.contains("active");

        if (!wasActive) {
          content.style.display = "block";
          content.style.position = "absolute";
          content.style.visibility = "hidden";
          content.style.pointerEvents = "none";
        }

        maxHeight = Math.max(maxHeight, content.offsetHeight);

        if (!wasActive) {
          content.style.display = "";
          content.style.position = "";
          content.style.visibility = "";
          content.style.pointerEvents = "";
        }
      });

      wrapper.style.minHeight = `${maxHeight}px`;
    }

    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        const targetId = this.getAttribute("data-tab-target");

        buttons.forEach((btn) => btn.classList.remove("active"));
        contents.forEach((content) => content.classList.remove("active"));

        this.classList.add("active");

        const target = tabs.querySelector(`#${CSS.escape(targetId)}`);
        if (target) target.classList.add("active");

        setWrapperHeight();
      });
    });

    setWrapperHeight();
    window.addEventListener("resize", setWrapperHeight);
  });
}

function increaseQty(sectionId) {
  const qtyInput = document.getElementById(`qty-${sectionId}`);
  const hiddenInput = document.getElementById(`qty-hidden-${sectionId}`);
  let value = parseInt(qtyInput.value || "1", 10);
  value += 1;
  qtyInput.value = value;
  hiddenInput.value = value;
}

function decreaseQty(sectionId) {
  const qtyInput = document.getElementById(`qty-${sectionId}`);
  const hiddenInput = document.getElementById(`qty-hidden-${sectionId}`);
  let value = parseInt(qtyInput.value || "1", 10);
  value = Math.max(1, value - 1);
  qtyInput.value = value;
  hiddenInput.value = value;
}

function initJvProductBodySystems() {
  document.querySelectorAll("[data-jvps-systems-root]").forEach(function (root) {
    var pills = root.querySelectorAll("[data-jvps-system]");
    var panels = root.querySelectorAll("[data-jvps-system-panel]");
    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        var key = pill.getAttribute("data-jvps-system");
        pills.forEach(function (p) {
          var on = p.getAttribute("data-jvps-system") === key;
          p.classList.toggle("jvps-sys__pill--active", on);
          p.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute("data-jvps-system-panel") === key;
          panel.classList.toggle("jvps-sys__panel--active", on);
        });
      });
    });
  });
}

/** After Seal widget mounts on JVP, nudge subscribe where markup allows (Seal admin sets true default). */
function initSealDefaultSubscribe() {
  if (!document.querySelector(".jvp")) return;

  function trySeal() {
    var el =
      document.querySelector('[data-seal-subscription-option="subscribe"]') ||
      document.querySelector(".seal-subscriptions [data-frequency='subscribe']") ||
      document.querySelector('fieldset.seal-sales label input[value="subscription"]');

    var radios = Array.prototype.slice.call(
      document.querySelectorAll(
        'input[type="radio"][name="selling_plan"], input[type="radio"][name*="Seal"], input[type="radio"][name*="purchase"]'
      )
    );

    function pickSubscribeRadio(inputs) {
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        var v = (inp.getAttribute("value") || "").toLowerCase();
        if (!inp.value || v === "") continue;
        var lab = inp.closest("label");
        var text = "";
        try {
          text = lab ? lab.textContent : "";
        } catch (e2) {}
        if (
          v.indexOf("sub") !== -1 ||
          (text && text.toLowerCase().indexOf("subscribe") !== -1) ||
          (text && text.toLowerCase().indexOf("delivery") !== -1 && text.toLowerCase().indexOf("one") === -1)
        )
          return inp;
      }
      if (inputs.length === 1) return inputs[0];
      return null;
    }

    var radioSubscribe = radios.length ? pickSubscribeRadio(radios) : null;

    try {
      if (el) el.click();
      else if (radioSubscribe) radioSubscribe.click();
    } catch (e3) {}
  }

  [500, 1500, 3000].forEach(function (ms) {
    setTimeout(trySeal, ms);
  });
}

function initJvPdpStickyBuyBar() {
  document.querySelectorAll("[data-jvp-sticky-atc]").forEach(function (btn) {
    btn.addEventListener("click", async function () {
      var wrapper = btn.closest("#jvp-sticky-buy");
      if (!wrapper) return;

      var variantId = wrapper.dataset.variantId;
      var sellingPlan = wrapper.dataset.sellingPlan;

      var item = {
        id: parseInt(variantId, 10),
        quantity: 1,
      };

      if (sellingPlan) {
        item.selling_plan = parseInt(sellingPlan, 10);
      }

      btn.disabled = true;
      btn.textContent = "ADDING...";

      try {
        var response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [item] }),
        });

        if (response.ok) {
          window.location.href =
            typeof window.routes !== "undefined" && window.routes.cart_url ? window.routes.cart_url : "/cart";
        } else {
          btn.disabled = false;
          btn.textContent = "ADD";
          console.error("Add to cart failed:", await response.text());
          alert("Could not add to cart. Please try the main Add to Cart button.");
        }
      } catch (err) {
        btn.disabled = false;
        btn.textContent = "ADD";
        console.error("Cart error:", err);
      }
    });
  });

  var bar = document.getElementById("jvp-sticky-buy");
  var root = document.querySelector(".jvp");
  if (!bar || !root || !window.IntersectionObserver) return;

  var sentinel =
    document.querySelector(".jvp #jv-product-hero-trigger") ||
    document.querySelector(".jvp .jvp__media") ||
    root.querySelector(".jv-product-hero-trigger");
  if (!sentinel) return;

  var io = new IntersectionObserver(
    function (entries) {
      var intersecting = entries[0].isIntersecting;
      bar.classList.toggle("jvp__sticky-buy--visible", !intersecting);
      bar.setAttribute("aria-hidden", intersecting ? "true" : "false");
    },
    {
      root: null,
      rootMargin: "0px 0px -50% 0px",
      threshold: 0,
    }
  );
  io.observe(sentinel);
}

/** Story / Science long-form pages: VIEW PRODUCT sticky after ~1 viewport scroll */
function initJvLandingStickyBuyBar() {
  var bar = document.getElementById("jv-sticky-buy-landing");
  if (!bar) return;

  function sync() {
    var vh = window.innerHeight || 0;
    var show = (window.scrollY || window.pageYOffset || 0) >= vh;
    bar.classList.toggle("jvp__sticky-buy--visible", show);
    bar.setAttribute("aria-hidden", show ? "false" : "true");
  }

  window.addEventListener("scroll", sync, { passive: true });
  window.addEventListener("resize", sync);
  sync();
}

/** Scoped Jiva lift: product + Science pages only; translateY while sticky visible — no global widget CSS */
(function () {
  var path = window.location.pathname || "";
  var onProduct = /(^|\/)products\//.test(path);
  var onScience = /(^|\/)pages\/science(\/|$|\?)/.test(path);
  if (!onProduct && !onScience) return;

  var stickyBars = document.querySelectorAll(".jvp__sticky-buy, .jv-sticky-buy");
  if (!stickyBars.length) return;

  function getJivaWidget() {
    return (
      document.querySelector("#jiva-widget-root") ||
      document.querySelector("#jivaka-widget-host") ||
      document.querySelector("#jiva-widget-host") ||
      document.querySelector('[id*="jivaka-widget"]') ||
      document.querySelector('[id*="jiva-widget"]')
    );
  }

  function anyStickyVisible() {
    return Array.prototype.some.call(stickyBars, function (bar) {
      return (
        bar.getAttribute("aria-hidden") === "false" ||
        bar.classList.contains("is-visible") ||
        bar.classList.contains("jvp__sticky-buy--visible")
      );
    });
  }

  function applyLift() {
    var widget = getJivaWidget();
    if (!widget) return;

    if (anyStickyVisible()) {
      widget.style.transition = "transform 0.3s ease";
      widget.style.transform = "translateY(-80px)";
    } else {
      widget.style.transform = "";
    }
  }

  stickyBars.forEach(function (bar) {
    var observer = new MutationObserver(applyLift);
    observer.observe(bar, {
      attributes: true,
      attributeFilter: ["class", "aria-hidden"],
    });
  });

  applyLift();
  setTimeout(applyLift, 1500);
  setTimeout(applyLift, 3500);
})();
